<template>
  <!-- Table Container Card -->
  <b-card id="page-binacle-emails" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-center"
    >
      <b-col cols="12">
        <b-card-title
          ><h2>{{ $t(label("title-binnacle-emails")) }}</h2></b-card-title
        >
      </b-col>
    </b-card-header>

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />

    <!-- Table for larger devices -->
    <b-table
      id="binacle-emails-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>
      <template #cell(toEmail)="data">
        <slot name="cell-toEmail" :data="data">
          {{ data.item.toEmail || "N/A" }}
        </slot>
      </template>

      <template #cell(success)="data">
        <slot name="cell-success" :data="data">
          <b-badge pill :variant="tagsColor(data.item.success)">
            <span>{{ data.item.success ? "Enviado" : "No enviado" }}</span>
          </b-badge>
        </slot>
      </template>

      <template #cell(failureReasonEx)="data">
        <slot name="cell-failureReasonEx" :data="data">
          {{ data.item.failureReasonEx || "N/A" }}
        </slot>
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.idBitacoraEnvioCorreo"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong>
              {{ $t(labelHeader("email")) }} :
              {{ item.toEmail || "N/A" }}</strong
            >
          </div>
          <p class="m-0">
            <strong>{{ $t(labelHeader("status")) }}: </strong>
            <b-badge pill :variant="tagsColor(item.success)">
              <span>{{ item.success ? "Enviado" : "No enviado" }}</span>
            </b-badge>
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("is_failure")) }}: </strong>
            {{ item.failureReasonEx || "N/A" }}
          </p>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading">
          <b-spinner variant="success"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BPagination,
  BToast,
  BSpinner,
  BBadge,
  VBTooltip,
  BTooltip,
  BFormSelect,
  BFormGroup,
  BCardGroup,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Filterss from "../components/filters/Filterss.vue";
import { allSentEmails } from "@core/api/request/binnacle.js";
import { getParams } from "@core/utils/utils";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BToast,
    BSpinner,
    BBadge,
    BFormSelect,
    BFormGroup,
    BTooltip,
    Filterss,
    BCardGroup,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
  },
  directives: {
    "b-tooltip": BTooltip,
    Ripple,
  },
  data: () => ({
    model: "binnacle",
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "email", key: "toEmail", sortable: false },
      { label: "status", key: "success", sortable: false },
      { label: "is_failure", key: "failureReasonEx", sortable: false },
    ],
    fildsToFilters: [
      {
        name: "name",
        title: "email",
        placeholder: "email",
        type: "search",
        visible: true,
      },
    ],
    appliedFilters: {},
  }),

  computed: {},

  watch: {},
  created() {
    this.loadData();
  },
  mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const params = this.chargeParams();
        const [emailsResp] = await Promise.all([allSentEmails(params)]);

        // correos enviados
        const emails = _.get(emailsResp, "data");
        this.items = emails?.items || [];
        this.totalRows = emails?.totalRows || 0;
        this.hasNextPage = emails?.currentPage < emails?.totalPages || 0;
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error loading data", error.message);
      } finally {
        this.loading = false;
      }
    },
    async loadEmailsInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const params = this.chargeParams();
        allSentEmails(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading products infinitely", error);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error cargando productos infinitamente", error.message);
      }
    },
    label(field) {
      return `pages.binnacle.table.${field}`;
    },
    labelHeader(field) {
      return `pages.binnacle.table.tableHeader.${field}`;
    },
    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);
      arrParams.push(`active,${true}`);

      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }

      return getParams(arrParams);
    },

    tagsColor(type) {
      if (type) return "light-success";
      else return "light-danger";
    },
    async handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        await this.loadUsersInfinity();
      }
    },

    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },

    handlePerPageChange() {
      this.loadData();
    },

    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      return true;
    },

    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },

    resetFilters() {
      console.log("Resetting filters");
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },
  },
};
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
</style>
